import NotificationApi from "@/apis/Notification.api";

const state = {
    data:{
        unread: 0
    }
};
const getters = {
    getData: state => state.data
};
const mutations = {
    SET_DATA: (state, data) => {
        state.data = {
            unread: data
        };
    },
    REMOVE_DATA: state => {
        state.data = {
            unread: 0
        };
    }
};
const actions = {
    setData: async ({commit}) => {
        const response = await NotificationApi.TotalUnread();
        commit("SET_DATA", response.data)
    },
    removeData: ({commit}) => commit("REMOVE_DATA"),
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
